import { render } from "./SocialAuth.vue?vue&type=template&id=3b6008b1&scoped=true"
import script from "./SocialAuth.vue?vue&type=script&lang=js"
export * from "./SocialAuth.vue?vue&type=script&lang=js"

import "./SocialAuth.vue?vue&type=style&index=0&id=3b6008b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6008b1"]])

export default __exports__